import { makeHttpRequest } from "@/shared";

export const deleteRepair = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/${id}`,
            method: "DELETE",
        })
    ).data;

    return response;
};
